import { getFieldNameWithPrefix } from '@monorepo/shared/componentsV2/fields/fieldUtils';
import React from 'react';
import { ModalFieldWrapper, ModalTextField } from '../../styled';

type EditHelperTextFieldProps = {
  prefix?: string;
};

export function EditHelperTextField({ prefix }: EditHelperTextFieldProps) {
  return (
    <ModalFieldWrapper>
      <ModalTextField
        label="Helper text"
        name={getFieldNameWithPrefix('helpText', prefix)}
        tooltipText="Optional. Helper text is viewed by customers when they hover over the “i” to the right of the field name. If you want to be sure that users see the text, make it subtext, not helper text."
      />
    </ModalFieldWrapper>
  );
}
